export function clamp(t, _ref) {
  let [a, n] = _ref;
  return Math.min(n, Math.max(a, t));
}